import { render, staticRenderFns } from "./RestoreBackupDialog.vue?vue&type=template&id=da85d1f2&"
import script from "./RestoreBackupDialog.vue?vue&type=script&lang=ts&"
export * from "./RestoreBackupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreBackupDialog.vue?vue&type=style&index=0&id=da85d1f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports